import { lazy } from 'ice';
import React from 'react';
import { MyComponentType } from '../component-factory/component-types';
import { ComponentIdEnum } from '../component-factory/ComponentIdEnum';
import { ConfigHOC } from '../HOC';
import { ElementConfigType } from '../store/type';

type Props = ElementConfigType;
const RichTextComponent: MyComponentType<Props> = (props: Props) => {
  const { parentNodeIsBody, id } = props;
  return (
    <div
      id={id}
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
      dangerouslySetInnerHTML={{ __html: props.privateSchema?.html }}
    />
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/RichTextComponentDefinition'));

RichTextComponent.definition = {
  id: ComponentIdEnum.RICH_TEXT_COMPONENT,
  name: '富文本组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/dIVTg-dEwgXAOViujW2tP.png?image_process=resize,w_200',
  position: 13, // 显示顺序
  config: {
    text: 'Why Choose FEZIBO?',
  },
  privateSchema: {
    editorState: {},
    html: '<h1>占位，不要把富文本编辑器的内容删到没有</h1><h1>占位，不要把富文本编辑器的内容删到没有</h1><h1>占位，不要把富文本编辑器的内容删到没有</h1>',
  },
  category: 'text',
  configForm: ConfigHOC(ConfigForm),
};

export { RichTextComponent };
